import { memo } from 'react';
import { useEditorState, useObjectEditor } from '../EditorContext';
import { GroupInspector } from './GroupInspector';
import { ObjectSettings } from './ObjectSettings';
import { ParamInspector } from './ParamInspector';
import { ShapeInspector } from './ShapeInspector';
import { TestPanel } from './TestPanel';

/** The right panel: Test mode's placement stand-in, or the properties of what is selected (the object itself when nothing is). */
const Inspector_: React.FC = () => {
  const { ui } = useObjectEditor();
  const { selection } = useEditorState();
  if (ui.mode === 'test') return <TestPanel />;
  switch (selection.kind) {
    case 'shapes':
      return <ShapeInspector ids={selection.ids} />;
    case 'group':
      return <GroupInspector key={selection.id} id={selection.id} />;
    case 'param':
      return <ParamInspector key={selection.key} paramKey={selection.key} />;
    case 'none':
      return <ObjectSettings />;
  }
};

export const Inspector = memo(Inspector_);
